const videoSource19 = [
  {
    id: "video16",
    src: require("./3_1.mp4"),
  },
  {
    id: "video17",
    src: require("./3_2.mp4"),
  },
  {
    id: "video18",
    src: require("./3_3.mp4"),
  },
];

export default videoSource19;
